"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnPromotionComponent = void 0;
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var products_list_1 = require("../../../../api/calls/product/products_list");
var add_product_thunk_1 = require("../../../../reducers/slices/basket/thunks/add_product_thunk");
var react_redux_1 = require("react-redux");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var pro_solid_svg_icons_2 = require("@fortawesome/pro-solid-svg-icons");
var get_favourite_products_1 = require("../../../../api/calls/product/get_favourite_products");
var favourite_product_1 = require("../../../../api/calls/product/favourite_product");
var main_1 = require("../../../../reducers/slices/main");
var image_default_png_1 = __importDefault(require("../../../../assets/image_default.png"));
var symbols_1 = require("../../../../constants/symbols");
var OnPromotionComponent = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_1.useState)([]), products = _a[0], setProducts = _a[1];
    var _b = (0, react_1.useState)([]), productsItems = _b[0], setProductItems = _b[1];
    var _c = (0, react_1.useState)([]), favouriteProducts = _c[0], setFavouriteProducts = _c[1];
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    (0, react_1.useEffect)(function () {
        init();
    }, [user]);
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(user === null || user === void 0 ? void 0 : user.uid)) return [3 /*break*/, 1];
                    (0, get_favourite_products_1.get_favourite_products)().then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!response.success) return [3 /*break*/, 2];
                                    return [4 /*yield*/, setFavouriteProducts(response.content)];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, setFavouriteProducts([])];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        (0, products_list_1.get_product_list)({
            on_promotion: true,
            size: "20",
        }).then(function (data) {
            var _a;
            if (data) {
                setProducts((_a = data === null || data === void 0 ? void 0 : data.content) === null || _a === void 0 ? void 0 : _a.product_list);
            }
        });
        //
    }, []);
    (0, react_1.useEffect)(function () {
        var _a;
        var mappedProducts = [];
        var _loop_1 = function (product) {
            mappedProducts.push({
                _id: product === null || product === void 0 ? void 0 : product._id,
                image: (_a = product.image_url) !== null && _a !== void 0 ? _a : image_default_png_1.default,
                title: product === null || product === void 0 ? void 0 : product.title,
                titleColor: "text-secondary",
                amount: product === null || product === void 0 ? void 0 : product.price,
                borderColor: "border-none",
                amountColor: "text-secondary",
                shadowColor: "shadow-shadows",
                //rating: product?.rating?.average ?? 0,
                discountLabel: (product === null || product === void 0 ? void 0 : product.on_promotion) ? "ON PROMOTION" : "",
                discountAmount: (product === null || product === void 0 ? void 0 : product.on_promotion) ? product === null || product === void 0 ? void 0 : product.promotion_price : null,
                extraText: product.estimated_delivery_time ? "Estimated Delivery: ".concat(product.estimated_delivery_time, " ") : "",
                pid: product === null || product === void 0 ? void 0 : product.pid,
                sku: product === null || product === void 0 ? void 0 : product.sku,
                sub_title: product === null || product === void 0 ? void 0 : product.sub_title,
                description: product === null || product === void 0 ? void 0 : product.description,
                instruction: product === null || product === void 0 ? void 0 : product.instruction,
                estimated_delivery_time: product === null || product === void 0 ? void 0 : product.estimated_delivery_time,
                promotion_price: product === null || product === void 0 ? void 0 : product.promotion_price.toString(),
                on_promotion: product === null || product === void 0 ? void 0 : product.on_promotion,
                colors: {
                    discount: {
                        textColor: "text-tertiary",
                        amountColor: "text-red-500",
                        backgroundColor: "bg-red-500",
                    },
                    extraText: {
                        textColor: "text-primary",
                    },
                },
                favorite: {
                    icon: (favouriteProducts === null || favouriteProducts === void 0 ? void 0 : favouriteProducts.find(function (x) { return x.pid === product.pid; })) ? pro_solid_svg_icons_2.faHeart : (pro_light_svg_icons_1.faHeart !== null && pro_light_svg_icons_1.faHeart !== void 0 ? pro_light_svg_icons_1.faHeart : pro_light_svg_icons_1.faHeart),
                    iconColor: "text-red-500",
                    onClick: function () {
                        if (user === null || user === void 0 ? void 0 : user.uid) {
                            (0, favourite_product_1.favorite_product)({
                                product_id: product._id,
                            }).then(function (response) {
                                if (response.success) {
                                    init();
                                    dispatch((0, main_1.setMessageModal)({
                                        title: "Success",
                                        messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                    }));
                                }
                                else {
                                    dispatch((0, main_1.setMessageModal)({
                                        title: "Failed",
                                        messages: ["".concat(response === null || response === void 0 ? void 0 : response.message)],
                                    }));
                                }
                            });
                        }
                        else {
                            dispatch((0, main_1.setDrawerPage)("login"));
                            dispatch((0, main_1.setDrawerOpen)(true));
                        }
                    },
                },
            });
        };
        for (var _i = 0, _b = products !== null && products !== void 0 ? products : []; _i < _b.length; _i++) {
            var product = _b[_i];
            _loop_1(product);
        }
        setProductItems(mappedProducts);
    }, [products, favouriteProducts]);
    return (react_1.default.createElement("div", { className: "w-full" }, (productsItems === null || productsItems === void 0 ? void 0 : productsItems.length) > 0 ? (react_1.default.createElement("div", { className: "w-full" },
        react_1.default.createElement("div", { className: "bg-white p-2 flex" },
            react_1.default.createElement("div", { className: "flex gap-2 items-center flex-1" },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faFlame, className: "text-primary" }),
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "On Promotion!", textColor: "text-primary", size: "large", bold: true })),
            react_1.default.createElement("div", { className: "flex items-center justify-between" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "View All", size: "small", textColor: "text-secondary", backgroundColor: "bg-transparent", onClick: function () {
                        navigate("/hot-deals");
                    } }))),
        react_1.default.createElement("div", { className: " p-1" },
            react_1.default.createElement("div", { className: "flex flex-col" },
                react_1.default.createElement(doshx_controls_web_1.ProductCarouselBigControl, { currencySymbol: symbols_1.currencySymbol, category: {
                    // name: "Popular Search",
                    }, loop: false, canIncrement: true, button: {
                        label: "Add to Cart",
                        backgroundColor: "bg-primary",
                        textColor: "text-tertiary",
                        borderColor: "border-transparent",
                        icon: pro_solid_svg_icons_1.faCartArrowUp,
                        onClick: function (product) {
                            dispatch((0, add_product_thunk_1.add_product_thunk)(product));
                        },
                    }, products: productsItems, onClick: function (product) {
                        navigate("/product/".concat(product === null || product === void 0 ? void 0 : product._id));
                    } }))))) : ("")));
};
exports.OnPromotionComponent = OnPromotionComponent;
